import { Text, Box, Flex } from "@simplybusiness/mobius";

interface PersistentSummaryHeaderProps {
  text?: string;
}

export const PersistentSummaryHeader = ({
  text = "Your quoted coverages",
}: PersistentSummaryHeaderProps) => {
  return (
    <Box>
      <Flex className="coverage-widget-up-arrow" />
      <Flex>
        <Text
          className="coverage-title mobius-payment-summary__styled-coverage-text mobius-payment-summary__styled-box"
          elementType="span"
        >
          {text}
        </Text>
      </Flex>
    </Box>
  );
};
